import React, { lazy, Suspense } from 'react';

const LazyDetailDataTransmission = lazy(() => import('./DetailDataTransmission'));

const DetailDataTransmission = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
    <Suspense fallback={null}>
        <LazyDetailDataTransmission {...props} />
    </Suspense>


);

export default DetailDataTransmission;
